import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-analyticsmenu',
  templateUrl: './analyticsmenu.component.html',
  styleUrls: ['./analyticsmenu.component.css']
})
export class AnalyticsmenuComponent implements OnInit {
  analytics_view: string;
  @Output() clickedAnalytics = new EventEmitter();
  @Output() clickedData = new EventEmitter();
  constructor() {
  }

  ngOnInit() {
  }
  analyticsView() {
    this.clickedAnalytics.emit();
    //console.log(this.analytics_view);
  }

  dataView() {
    this.clickedData.emit();
  }
}
